
// Action Types
export const SEARCH_VACCINES_REQUEST = 'SEARCH_VACCINES_REQUEST';
export const SEARCH_VACCINES_SUCCESS = 'SEARCH_VACCINES_SUCCESS';
export const SEARCH_VACCINES_FAILURE = 'SEARCH_VACCINES_FAILURE';
export const SEARCH_IMMUNIZATIONS_REQUEST = 'SEARCH_IMMUNIZATIONS_REQUEST';
export const SEARCH_IMMUNIZATIONS_SUCCESS = 'SEARCH_IMMUNIZATIONS_SUCCESS';
export const SEARCH_IMMUNIZATIONS_FAILURE = 'SEARCH_IMMUNIZATIONS_FAILURE';

export const ADD_VACCINE_REQUEST = 'ADD_VACCINE_REQUEST';
export const ADD_VACCINE_SUCCESS = 'ADD_VACCINE_SUCCESS';
export const ADD_VACCINE_FAILURE = 'ADD_VACCINE_FAILURE';
export const ADD_IMMUNIZATION_REQUEST = 'ADD_IMMUNIZATION_REQUEST';
export const ADD_IMMUNIZATION_SUCCESS = 'ADD_IMMUNIZATION_SUCCESS';
export const ADD_IMMUNIZATION_FAILURE = 'ADD_IMMUNIZATION_FAILURE';


export const EDIT_VACCINE_REQUEST = 'EDIT_VACCINE_REQUEST';
export const EDIT_VACCINE_SUCCESS = 'EDIT_VACCINE_SUCCESS';
export const EDIT_VACCINE_FAILURE = 'EDIT_VACCINE_FAILURE';
export const EDIT_IMMUNIZATION_REQUEST = 'EDIT_IMMUNIZATION_REQUEST';
export const EDIT_IMMUNIZATION_SUCCESS = 'EDIT_IMMUNIZATION_SUCCESS';
export const EDIT_IMMUNIZATION_FAILURE = 'EDIT_IMMUNIZATION_FAILURE';

export const VIEW_VACCINE_REQUEST = 'VIEW_VACCINE_REQUEST';
export const VIEW_VACCINE_SUCCESS = 'VIEW_VACCINE_SUCCESS';
export const VIEW_VACCINE_FAILURE = 'VIEW_VACCINE_FAILURE';
export const VIEW_IMMUNIZATION_REQUEST = 'VIEW_IMMUNIZATION_REQUEST';
export const VIEW_IMMUNIZATION_SUCCESS = 'VIEW_IMMUNIZATION_SUCCESS';
export const VIEW_IMMUNIZATION_FAILURE = 'VIEW_IMMUNIZATION_FAILURE';
export const LOAD_VACCINE_REQUEST = 'LOAD_VACCINE_REQUEST';
export const LOAD_VACCINE_SUCCESS = 'LOAD_VACCINE_SUCCESS';
export const LOAD_VACCINE_FAILURE = 'LOAD_VACCINE_FAILURE';


export const UPDATE_VACCINE_STATUS_REQUEST ='UPDATE_VACCINE_STATUS_REQUEST';
export const UPDATE_VACCINE_STATUS_SUCCESS = 'UPDATE_VACCINE_STATUS_SUCCESS';
export const UPDATE_VACCINE_STATUS_FAILURE = 'UPDATE_VACCINE_STATUS_FAILURE';
export const UPDATE_IMMUNIZATION_STATUS_REQUEST = 'UPDATE_IMMUNIZATION_STATUS_REQUEST';
export const UPDATE_IMMUNIZATION_STATUS_SUCCESS = 'UPDATE_IMMUNIZATION_STATUS_SUCCESS';
export const UPDATE_IMMUNIZATION_STATUS_FAILURE = 'UPDATE_IMMUNIZATION_STATUS_FAILURE';

export const DELETE_VACCINE_REQUEST='DELETE_VACCINE_REQUEST';
export const DELETE_VACCINE_SUCCESS='DELETE_VACCINE_SUCCESS';
export const DELETE_VACCINE_FAILURE = 'DELETE_VACCINE_FAILURE';
export const DELETE_IMMUNIZATION_REQUEST = 'DELETE_IMMUNIZATION_REQUEST';
export const DELETE_IMMUNIZATION_SUCCESS = 'DELETE_IMMUNIZATION_SUCCESS';
export const DELETE_IMMUNIZATION_FAILURE = 'DELETE_IMMUNIZATION_FAILURE';
export const CANCEL_IMMUNIZATION_FORM='CANCEL_IMMUNIZATION_FORM';
export const CLEAR_VACCINE= 'CLEAR_VACCINE';
//Views
export const INITIALIZE_NEW_VACCINE='INITIALIZE_NEW_VACCINE';
export const ADD_EDIT_VACCINE_VIEW = 'ADD_EDIT_VACCINE_VIEW';
export const INITIALIZE_NEW_IMMUNIZATION = 'INITIALIZE_NEW_IMMUNIZATION';
export const ADD_EDIT_IMMUNIZATION_VIEW = 'ADD_EDIT_IMMUNIZATION_VIEW';
export const SEARCH_VACCINES_VIEW = 'SEARCH_VACCINES_VIEW';
export const VIEW_VACCINE_VIEW = 'VIEW_VACCINE_VIEW';

export const SEARCH_IMMUNIZATIONS_VIEW = 'SEARCH_IMMUNIZATIONS_VIEW';

